import { render, staticRenderFns } from "./publisher-group-edit.vue?vue&type=template&id=7c4a4770&"
import script from "./publisher-group-edit.vue?vue&type=script&lang=js&"
export * from "./publisher-group-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports